import React from "react";
import PropTypes from "prop-types";
import { Redirect } from 'react-router-dom';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import changePasswordStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Clearfix from "components/Clearfix/Clearfix.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";

import PhoneIcon from "@material-ui/icons/Phone";
import ConfirmDialog from 'customs/components/ConfirmDialog';

import { connect } from 'react-redux';
import { doFetchUserDetails, doUpdateProfile } from '../../store/actions/authActions';

import AuthService from 'customs/auth/AuthService';
import validations from "customs/helpers/validations";
import helpers from "customs/helpers/helpers";

class ChangePassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tr: false,
      confirmModal: false,
      confirmModalTitle: '',
      confirm_phone: "",
      new_phone: ""
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleClose(modal) {
    var x = [];
    x[modal] = false;
    this.setState(x);
  }
  
  handleChange(event) {
    this.setState({ [event.target.id]: event.target.value, [event.target.id + '_valid']: "" });
  }

  componentDidMount () {
    if (!this.props.me) {
      helpers.showLoading();
      this.props.doFetchUserDetails({ ...this.props });
    }
  }

  handleUpdateProfileClick () {
    let cont = true;
    const is_valid_phone = validations.validatePhone(this.state.new_phone);
    const is_confirm_valid_phone = validations.validatePhone(this.state.confirm_phone);

    if (!is_valid_phone) {
      cont = false;
      this.setState({ "new_phone_valid": "error", "new_phone_error": validations.phoneErrorMsg() });
    } else {
      this.setState({"new_phone_valid" : "", "new_phone_error": ""});
    }

    if (!is_confirm_valid_phone) {
      cont = false;
      this.setState({ "confirm_phone_valid": "error", "confirm_phone_error": validations.phoneErrorMsg() });
    } else {
      this.setState({"confirm_phone_valid" : "", "confirm_phone_error": ""});
    }

    if (is_valid_phone && is_confirm_valid_phone && this.state.new_phone !== this.state.confirm_phone) {
      cont = false;
      this.setState({ "confirm_phone_valid": "error", "confirm_phone_error": "The phone confirmation does not match" });
    }

    if (cont) {
      var x = [];
      x['confirmModal'] = true;
      this.setState({...x, 'confirmModalTitle': 'Change phone number'});
    }
  }

  doChangePhoneClick() {
    helpers.showLoading();
    this.handleClose("confirmModal");

    let me = {};
    me['name'] = this.props.me.name;
    me['email'] = this.props.me.email;
    me['phone'] = this.state.new_phone;
    if (this.props.me.address1) me['address1'] = this.props.me.address1;
    if (this.props.me.address2) me['address2'] = this.props.me.address2;
    if (this.props.me.city) me['city'] = this.props.me.city;
    if (this.props.me.state) me['state'] = this.props.me.state;
    if (this.props.me.country) me['country'] = this.props.me.country;
    if (this.props.me.postal_code) me['postal_code'] = this.props.me.postal_code;

    this.props.doUpdateProfile(me, { ...this.props });
  }

  render() {
    const authService = new AuthService(this.state, this.props);
    if (!authService.getToken())
      return (<div><Redirect to="/auth/login"/></div>);

    let new_phone_valid = this.state.new_phone_valid;
    let new_phone_error = this.state.new_phone_valid === "error" && this.state.new_phone
      ? (this.state.new_phone_error ? this.state.new_phone_error : validations.phoneErrorMsg()) : undefined;
    let confirm_phone_valid = this.state.confirm_phone_valid;
    let confirm_phone_error = this.state.confirm_phone_valid === "error" && this.state.confirm_phone
      ? (this.state.confirm_phone_error ? this.state.confirm_phone_error : validations.phoneErrorMsg()) : undefined;

    const profileUpdated = this.props.auth && this.props.auth.authMessage ? this.props.auth.authMessage : '';
    if (profileUpdated) {
     this.props.auth.authMessage = '';
      setTimeout( function() {
        this.setState({profileUpdated,});
        if (profileUpdated === 'Profile Updated')
          this.setState({new_phone: "", confirm_phone: ""});
        helpers.hideLoading();
      }.bind(this), 100 );
    }

    const { classes } = this.props;
    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={6}>
            <Card>
              <CardHeader color="primary" icon>
                <CardIcon color="primary">
                  <PhoneIcon />
                </CardIcon>
              </CardHeader>
              {
                this.state.profileUpdated
                  ? <CardBody style={{paddingBottom:'0px'}}>
                    <h4 className={classes.textCenter} id="reset_password_status" style={{color: this.state.profileUpdated === 'Profile Updated' ? '#4caf50' : 'red', marginBottom:'0px', paddingBottom:'0px'}}>
                      {this.state.profileUpdated === 'Profile Updated' ? "Phone number updated" : this.state.profileUpdated}
                    </h4>
                    </CardBody>
                  : ''
              }
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      success={this.state.phone_valid === "success"}
                      error={this.state.phone_valid === "error"}
                      labelText="Phone number"
                      id="phone"
                      helperText={ this.state.phone_valid === "error" && this.state.phone ? validations.phoneErrorMsg()  : undefined }
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        disabled: true,
                        onChange: this.handleChange,
                        value: this.props.me && this.props.me.phone ? this.props.me.phone : ''
                      }}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      success={new_phone_valid === "success"}
                      error={new_phone_valid === "error"}
                      labelText="New phone number"
                      id="new_phone"
                      formControlProps={{
                        fullWidth: true
                      }}
                      helperText={ new_phone_error }
                      inputProps={{
                        type: "number",
                        onChange: this.handleChange,
                        value: this.state.new_phone
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      success={confirm_phone_valid === "success"}
                      error={confirm_phone_valid === "error"}
                      labelText="Confirm phone number"
                      id="confirm_phone"
                      formControlProps={{
                        fullWidth: true
                      }}
                      helperText={ confirm_phone_error }
                      inputProps={{
                        type: "number",
                        onChange: this.handleChange,
                        value: this.state.confirm_phone
                      }}
                    />
                  </GridItem>
                </GridContainer>
                <Button color="primary" className={classes.updateProfileButton} onClick={() => this.handleUpdateProfileClick("confirmModal")}>
                  Update Phone Number
                </Button>
                <Clearfix />
              </CardBody>
            </Card>
          </GridItem>
          <ConfirmDialog
            confirmModal={this.state.confirmModal}
            confirmModalTitle={this.state.confirmModalTitle}
            onClose={() => this.handleClose("confirmModal")} 
            onYesClick={() => this.doChangePhoneClick()} />
        </GridContainer>
      </div>
    );
  }
}

ChangePassword.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = (state, props) => {
  helpers.hideLoading();
  return {
    auth: state.auth.data,
    me: state.auth.me,
    force_render: Math.random(),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    doFetchUserDetails: (props) => dispatch(doFetchUserDetails(props)),
    doUpdateProfile: (params, props) => dispatch(doUpdateProfile(params, props))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(changePasswordStyle)(ChangePassword));
